// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { common } from '../../tokens/primitiveColors/common';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { inverseBackground, inverseIcon, inverseText } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var chipColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    var inverseBg = inverseBackground(mode);
    var inverseIc = inverseIcon(mode);
    var inverseTx = inverseText(mode);
    return {
        // Filled/Outlined: Figma aliases `icon` to the SAME Text Colors token as `text`
        // (not a distinct Icon Colors token) for every variant here — verified via alias
        // chain, confirmed by hex (e.g. Filled/Error/Icon and /Text both resolve to Text
        // Colors/Status/Error Alt, #A41F04, not Icon Colors/Status/Error-Bold's #CB2B0B).
        filled: {
            default: {
                background: bg.level200,
                icon: tx.secondary,
                text: tx.secondary
            },
            error: {
                background: bg.status.error1,
                border: bd.status.error,
                icon: tx.status.errorAlt,
                text: tx.status.errorAlt
            },
            gray: {
                background: bg.level300,
                icon: tx.primary,
                text: tx.primary
            },
            info: {
                background: bg.status.info,
                icon: tx.status.infoAlt,
                text: tx.status.infoAlt
            },
            special: {
                background: bg.status.special,
                icon: tx.status.specialAlt,
                text: tx.status.specialAlt
            },
            success: {
                background: bg.status.success2,
                icon: tx.status.success,
                text: tx.status.success
            },
            warning: {
                background: bg.status.warning2,
                border: bd.status.warning,
                icon: tx.status.warningAlt,
                text: tx.status.warningAlt
            }
        },
        outlined: {
            default: {
                border: bd.default,
                icon: tx.secondary,
                text: tx.secondary
            },
            error: {
                border: bd.status.errorSoft,
                icon: tx.status.errorAlt,
                text: tx.status.errorAlt
            },
            gray: {
                border: bd.default,
                icon: tx.secondary,
                text: tx.secondary
            },
            info: {
                border: bd.status.infoSoft,
                icon: tx.status.infoAlt,
                text: tx.status.infoAlt
            },
            special: {
                border: bd.status.specialSoft,
                icon: tx.status.specialAlt,
                text: tx.status.specialAlt
            },
            success: {
                border: bd.status.successSoft,
                icon: tx.status.success,
                text: tx.status.success
            },
            warning: {
                border: bd.status.warningSoft,
                icon: tx.status.warningAlt,
                text: tx.status.warningAlt
            }
        },
        bold: {
            default: {
                background: inverseBg.level0,
                icon: inverseIc.active,
                text: inverseTx.primary
            },
            // Icon and Text both alias to Figma's "Text Colors/Action" token (not
            // Icon Colors/White) — verified via alias chain, diverges from ic.white/tx.white
            // in dark mode.
            error: {
                background: bg.status.errorBold4,
                icon: tx.action,
                text: tx.action
            },
            gray: {
                background: inverseBg.level300,
                icon: inverseIc.active,
                text: inverseTx.primary
            },
            // Icon aliases to Inverse/Icon Colors/Heaviest (not /Active) — verified via
            // alias chain (resolves to white, matching Figma's #FFFFFF).
            info: {
                background: bg.accent,
                icon: inverseIc.heaviest,
                text: tx.action
            },
            // Icon aliases to Text Colors/Action (not an inverse Icon Colors token) —
            // verified via alias chain.
            special: {
                background: bg.status.specialBold,
                icon: tx.action,
                text: tx.action
            },
            success: {
                background: bg.status.successBold2,
                icon: ic.black,
                text: tx.black
            },
            warning: {
                background: bg.status.warningBold1,
                icon: ic.black,
                text: tx.black
            },
            text: common.white
        },
        // BoldOutlined: `icon` aliases to the same Text Colors token as `text` for every
        // status variant except Info (which genuinely uses Icon Colors/Status/Info-Bold) —
        // verified via alias chain.
        boldOutlined: {
            default: {
                border: bd.heaviest,
                icon: ic.active,
                text: tx.primary
            },
            error: {
                border: bd.status.errorBold,
                icon: tx.status.errorBold,
                text: tx.status.errorBold
            },
            gray: {
                border: bd.heavy,
                icon: tx.primary,
                text: tx.primary
            },
            info: {
                border: bd.status.infoBold,
                icon: ic.status.infoBold,
                text: tx.status.infoBold
            },
            special: {
                border: bd.status.specialBold,
                icon: tx.status.specialBold,
                text: tx.status.specialBold
            },
            success: {
                border: bd.status.successBold,
                icon: tx.status.successBold,
                text: tx.status.successBold
            },
            warning: {
                border: bd.status.warningBold,
                icon: tx.status.warningBold,
                text: tx.status.warningBold
            }
        }
    };
};

//# sourceMappingURL=chipColors.js.map